<template>
  <div class="q-qr-container main-color">
    <label class="label-2cols q-label" v-html="question.q"></label>
    <qrcode-stream @decode="onDecode" @init="onInit" v-if="readOnly === false" />
     <p class="error qr-error">{{ error }}</p>
    <md-field>
      <md-input
        placeholder="Resultado"
        type="text"
        v-bind:disabled="true"
        v-model="answer"
        @change="emitValueOpen"
      ></md-input>
    </md-field>
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  name: "qr-question",
  components: { QrcodeStream },
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
    answerProp:{
      type: String,
      default: ""
    },
    readOnly:{
      type:Boolean,
      default: false
    }
  },
  methods: {
    onDecode: function(result) {
      this.answer = result;
      this.emitValueOpen();
      alert('QR leído correctamente');
    },
    async onInit (promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "Debes darle permiso al uso de la cámara para continuar";
        } else if (error.name === 'NotFoundError') {
          this.error = "Parece que tu dispositivo no cuenta con cámara, inténtalo con otro dispositivo";
        } else if (error.name === 'NotSupportedError') {
          this.error = "Dispositivo no soportado, por favor inténtalo con otro dispositivo";
        } else if (error.name === 'NotReadableError') {
          this.error = "Parece que la cámara esta en uso en otra aplicación, cierra los demás programas e inténtalo de nuevo";
        } else if (error.name === 'OverconstrainedError') {
          this.error = "Cámara no disponible, por favor inténtalo con otro dispositivo";
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "El navegador no soporta el uso de cámara, inténtalo con otro navegador";
        }
      }
    },
    emitValueOpen: function() {
      //console.log(this.answer);
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    }
  },
  data: function() {
    return {
      answer: this.answerProp,
      error: ""
    };
  }
};
</script>
